import { render, staticRenderFns } from "./ReindexThisLink.vue?vue&type=template&id=071f0356&"
import script from "./ReindexThisLink.vue?vue&type=script&lang=js&"
export * from "./ReindexThisLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ReindexThisLink.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports